import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { check, login } from '../../api/auth';

import loginLogo from '../../media/loginlogo.svg';
import ResetPasswordModal from './ResetPasswordModal';

const LoginScreen = ({ onLogin }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [error, setError] = useState();
  const [resetOpen, setResetOpen] = useState(false);

  const onSubmit = useCallback(async (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    const formValues = {
      username: formData.get('username'),
      password: formData.get('password'),
    };

    event.target.reset();

    await login(formValues)
      .then((res) => {
        onLogin(res);
        navigate('/');
      })
      .catch((e) => {
        setError(e);
      });
  }, []);

  useEffect(() => {
    const checkAuth = async () => {
      check().then((res) => {
        if (res) {
          onLogin(res);
          navigate('/');
        }
      });
    };

    checkAuth();
  }, []);

  return (
    <div className="login h-dvh w-dbw flex items-center justify-center bg-[#434c58]">
      <form className="login-container" onSubmit={onSubmit}>
        <img className="mx-auto my-6" src={loginLogo} alt="" />
        <div className="fields">
          <input name="username" type="text" placeholder={t('login.username_placeholder')} />
          <br />
          <input name="password" type="password" placeholder={t('login.password_placeholder')} />
        </div>
        <input className="button positive" type="submit" value={t('login.login_button')} />
        <br />
        <button
          className="text-[#FFFFFF] mt-16 text-[12px]"
          type="button"
          onClick={() => setResetOpen(true)}
        >
          Reset Password
        </button>
        {error && <p className="text-white">{error}</p>}
      </form>
      {resetOpen && (
        <ResetPasswordModal handleResetPasswordModalClose={() => setResetOpen(false)} />
      )}
    </div>
  );
};

export default LoginScreen;
